// eslint-disable-next-line import/no-named-as-default-member
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { languageDetector } from '../lib/language'

// Resources(English)
import enAccount from '../locales/en/account.json'
import enAdmin from '../locales/en/admin.json'
import enAbout from '../locales/en/about.json'
import enApp from '../locales/en/app.json'
import enBlog from '../locales/en/blog.json'
import enCards from '../locales/en/cards.json'
import enCheckout from '../locales/en/checkout.json'
import enCollections from '../locales/en/collections.json'
import enEbayPolicy from '../locales/en/ebay_policy.json'
import enErrors from '../locales/en/errors.json'
import enFooter from '../locales/en/footer.json'
import enHeader from '../locales/en/header.json'
import enImageUpload from '../locales/en/image_upload.json'
import enLinks from '../locales/en/links.json'
import enListings from '../locales/en/listings.json'
import enLogin from '../locales/en/login.json'
import enModal from '../locales/en/modal.json'
import enOrder from '../locales/en/order.json'
import enPhotos from '../locales/en/photos.json'
import enProfile from '../locales/en/profile.json'
import enRegister from '../locales/en/register.json'
import enSearch from '../locales/en/search.json'
import enSets from '../locales/en/sets.json'
import enTop from '../locales/en/top.json'
import enTranslation from '../locales/en/translation.json'

// Resources(Japanese)
import jaApp from '../locales/ja/app.json'
import jaAdmin from '../locales/ja/admin.json'
import jaAbout from '../locales/ja/about.json'
import jaAccount from '../locales/ja/account.json'
import jaBlog from '../locales/ja/blog.json'
import jaCards from '../locales/ja/cards.json'
import jaCheckout from '../locales/ja/checkout.json'
import jaCollections from '../locales/ja/collections.json'
import jaEbayPolicy from '../locales/ja/ebay_policy.json'
import jaErrors from '../locales/ja/errors.json'
import jaFooter from '../locales/ja/footer.json'
import jaHeader from '../locales/ja/header.json'
import jaImageUpload from '../locales/ja/image_upload.json'
import jaLinks from '../locales/ja/links.json'
import jaListings from '../locales/ja/listings.json'
import jaLogin from '../locales/ja/login.json'
import jaModal from '../locales/ja/modal.json'
import jaOrder from '../locales/ja/order.json'
import jaPhotos from '../locales/ja/photos.json'
import jaProfile from '../locales/ja/profile.json'
import jaRegister from '../locales/ja/register.json'
import jaSearch from '../locales/ja/search.json'
import jaSets from '../locales/ja/sets.json'
import jaTop from '../locales/ja/top.json'
import jaTranslation from '../locales/ja/translation.json'

const enResources = {
  ...enAccount,
  ...enAdmin,
  ...enAbout,
  ...enApp,
  ...enBlog,
  ...enCards,
  ...enCheckout,
  ...enCollections,
  ...enEbayPolicy,
  ...enErrors,
  ...enFooter,
  ...enHeader,
  ...enImageUpload,
  ...enLinks,
  ...enListings,
  ...enLogin,
  ...enModal,
  ...enOrder,
  ...enPhotos,
  ...enProfile,
  ...enRegister,
  ...enSearch,
  ...enSets,
  ...enTop,
  ...enTranslation,
}

const jaResources = {
  ...jaAccount,
  ...jaApp,
  ...jaAdmin,
  ...jaAbout,
  ...jaBlog,
  ...jaCards,
  ...jaCheckout,
  ...jaCollections,
  ...jaEbayPolicy,
  ...jaErrors,
  ...jaFooter,
  ...jaHeader,
  ...jaImageUpload,
  ...jaLinks,
  ...jaListings,
  ...jaLogin,
  ...jaModal,
  ...jaOrder,
  ...jaPhotos,
  ...jaProfile,
  ...jaRegister,
  ...jaSearch,
  ...jaSets,
  ...jaTop,
  ...jaTranslation,
}

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(languageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: {
      en: { translation: enResources },
      ja: { translation: jaResources },
    },
    fallbackLng: 'ja',
    supportedLngs: ['en', 'ja', 'cimode'],
    nonExplicitSupportedLngs: true,
    // debug: true,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  })

export { i18n }
